// React import removed - not needed
import { DropDownButtonComponent } from '@syncfusion/ej2-react-splitbuttons';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const languages = [
  { id: 'de', text: 'Deutsch', icon: '🇩🇪' }
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const defaultLanguage = languages[0].id;

  useEffect(() => {
    const isAllowed = languages.some(lang => lang.id === i18n.language);
    if (!isAllowed) {
      i18n.changeLanguage(defaultLanguage);
      localStorage.setItem('preferredLanguage', defaultLanguage);
    }
  }, [i18n, defaultLanguage]);

  const handleLanguageChange = (args: any) => {
    const langId = args.item.id;
    i18n.changeLanguage(langId);
    // Optionally save the language preference
    localStorage.setItem('preferredLanguage', langId);
  };

  const currentLang = languages.find(lang => lang.id === i18n.language) || languages[0];

  return (
    <DropDownButtonComponent
      items={languages}
      select={handleLanguageChange}
      cssClass="e-flat"
      content={`${currentLang.icon} ${currentLang.text}`}
    />
  );
} 